export default __webpack_public_path__ + "static/media/chessTalk.8c4434ea.webp";